import useAgentHubCommission from 'agentHub/hooks/useAgentHubCommissionV2'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const AgentPromotionLabel = styled(PromotionLabel)`
  &&&.kind-tertiary.variant-highlight {
    background-color: #0280B3;
    border-color: #0280B3;
    color: #003d37;
  }

  &&&.kind-tertiary.variant-highlight > svg,
  &&&.kind-tertiary.variant-highlight > * {
    color: #fff;
  }
`

const EARN_YOUR_OWN_TOUR_CAMPAIGN = 'earn-own-tour-campaign'

function AgentHubEarnYourOwnTourLabel({ offerId }: { offerId: string }) {
  const { campaigns } = useAgentHubCommission(offerId)

  if (!isAgentHubEnabled) {
    return null
  }
  if (!campaigns.includes(EARN_YOUR_OWN_TOUR_CAMPAIGN)) {
    return null
  }
  return (
    <AgentPromotionLabel variant="default" icon={<LineGlobeAltIcon />}>
      <FormattedMessage
        id="PXbr7Fh2FJEK76At3hip"
        defaultMessage="Book Tours, Earn Your Own"
        description="Earn your own tour label text in the agent hub portal"
      />
    </AgentPromotionLabel>
  )
}

export default AgentHubEarnYourOwnTourLabel
